/*
 * Home: proof (sections/home-proof.liquid).
 * 1. Film card: clicking the poster swaps in the film (from a <template>) with
 *    sound and controls.
 * 2. Strokes counter: base + (now - start) * rate, the same for every visitor.
 *    Every 10s it rolls up to the new value like an odometer: each digit is a
 *    0-9 strip moved with translateY; higher digits settle in 350ms, the tens
 *    in 800ms and the ones in 1.4s (quartic ease-out). Under reduced motion it
 *    snaps to the new value.
 */
(function () {
  var ROLL_EVERY = 10000;
  var ROLL_FOR = 1500;
  var FRAME = 40;
  // Conigen has no tabular figures, so each digit cell takes the width of the
  // digit it shows (em, Bold, -0.04em tracking; measured in the design file).
  var WIDTHS = { 0: 0.551, 1: 0.26, 2: 0.519, 3: 0.52, 4: 0.565, 5: 0.513, 6: 0.552, 7: 0.475, 8: 0.581, 9: 0.546 };

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function initFilm(root) {
    var film = root.querySelector('[data-film]');
    if (!film) return;
    var button = film.querySelector('[data-film-play]');
    var template = film.querySelector('[data-film-template]');
    if (!button || !template) return;

    button.addEventListener('click', function () {
      var node = template.content.cloneNode(true);
      var video = node.querySelector('video');
      button.remove();
      film.appendChild(node);
      if (video) {
        video = film.querySelector('video');
        // Shopify's video_tag adds `muted` whenever autoplay is set. This is
        // click-to-play with sound, and the click lets the browser play audio.
        video.removeAttribute('muted');
        video.muted = false;
        video.focus();
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }

  function format(n) {
    return Math.floor(n).toLocaleString('en-US');
  }

  function initCounter(root) {
    var el = root.querySelector('[data-counter]');
    if (!el) return;
    var digitsEl = el.querySelector('[data-counter-digits]');
    var liveEl = el.querySelector('[data-counter-live]');

    var base = parseFloat(el.getAttribute('data-base')) || 0;
    var start = Date.parse(el.getAttribute('data-start') || '');
    var rate = parseFloat(el.getAttribute('data-rate')) || 0;

    function target() {
      if (isNaN(start)) return Math.floor(base);
      return Math.floor(base + Math.max(0, Date.now() - start) / 1000 * rate);
    }

    var cells = [];

    // Build one cell per character of the formatted value. Rebuilt only when
    // the number of characters changes (a new digit or comma appears).
    function build(str) {
      digitsEl.textContent = '';
      cells = [];
      str.split('').forEach(function (ch) {
        if (/[0-9]/.test(ch)) {
          var cell = document.createElement('span');
          cell.className = 'home-counter__cell';
          var strip = document.createElement('span');
          strip.className = 'home-counter__strip';
          for (var i = 0; i < 10; i++) {
            var s = document.createElement('span');
            s.textContent = String(i);
            strip.appendChild(s);
          }
          cell.appendChild(strip);
          digitsEl.appendChild(cell);
          cells.push({ cell: cell, strip: strip, digit: null });
        } else {
          var sep = document.createElement('span');
          sep.className = 'home-counter__sep';
          sep.textContent = ch;
          digitsEl.appendChild(sep);
        }
      });
    }

    function paint(chars) {
      var di = 0;
      chars.forEach(function (ch) {
        if (!/[0-9]/.test(ch)) return;
        var c = cells[di++];
        if (!c || c.digit === ch) return;
        c.digit = ch;
        c.cell.style.width = WIDTHS[ch] + 'em';
        c.strip.style.transform = 'translateY(-' + ch + 'em)';
      });
    }

    // Digit by digit, so each position follows its own timing.
    function charsAt(from, to, elapsed) {
      var finalStr = format(to);
      var pos = 0;
      return finalStr.split('').reverse().map(function (ch) {
        if (!/[0-9]/.test(ch)) return ch;
        var dur = [1400, 800][pos] || 350;
        var t = Math.min(1, elapsed / dur);
        var e = 1 - Math.pow(1 - t, 4);
        var v = Math.round(from + (to - from) * e);
        var d = String(Math.floor(v / Math.pow(10, pos)) % 10);
        pos += 1;
        return d;
      }).reverse();
    }

    var shown = target();
    var str = format(shown);
    build(str);
    paint(str.split(''));
    if (liveEl) liveEl.textContent = str;

    var anim = null;

    function roll() {
      var from = shown;
      var to = target();
      if (to === from) return;
      var finalStr = format(to);
      if (finalStr.length !== format(from).length) build(finalStr);
      if (liveEl) liveEl.textContent = finalStr;

      clearInterval(anim);
      if ((reduce && reduce.matches) || document.hidden) {
        shown = to;
        paint(finalStr.split(''));
        return;
      }

      var t0 = Date.now();
      anim = setInterval(function () {
        var elapsed = Date.now() - t0;
        if (elapsed > ROLL_FOR) {
          clearInterval(anim);
          shown = to;
          paint(finalStr.split(''));
          return;
        }
        paint(charsAt(from, to, elapsed));
      }, FRAME);
    }

    setInterval(roll, ROLL_EVERY);
  }

  function init() {
    document.querySelectorAll('[data-home-proof]').forEach(function (root) {
      initFilm(root);
      initCounter(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
